import { Component, inject } from '@angular/core';
import { SpinnerService } from 'src/services/spinner.service';

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrl: './spinner.component.scss',
    standalone: false
})
export class SpinnerComponent {
  private spinnerService = inject(SpinnerService);

  isLoading$ = this.spinnerService.isLoading$;
  message$ = this.spinnerService.message$;
  style$ = this.spinnerService.style$;
}
